import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig
const headers = {
    token: localStorage.getItem(config.storageTokenKeyName),
    userID: localStorage.getItem('userID')
    }
  export const addStaff = createAsyncThunk('appStaff/Create', async (Staff) => {
    const response = await axios.post('https://api.zasway.com:8443/Staff/Create', Staff, {mode:'cors'})
    return response
  })

export const getStaffRole = createAsyncThunk('appStaff/getStaffRole', async () => {
  const response = await axios.post('https://api.zasway.com:8443/Staff/GetStaffRoleList', {headers})
  return response.data
  })

  export const getNationality = createAsyncThunk('appStaff/getNationality', async () => {
  const response = await axios.get('https://api.zasway.com:8443/Common/GetNationalityList', {headers})
  return response.data
  })

  export const getAllData = createAsyncThunk('appStaff/GetTableSummary', async (GetStaff) => {
  const response = await axios.post('https://api.zasway.com:8443/Staff/GetTableSummary', GetStaff, {mode:'cors'})
  return response.data
  })
  export const getStaffStats = createAsyncThunk('appStaff/GetStaffStatistics', async (GetStaff) => {
  const response = await axios.post('https://api.zasway.com:8443/Staff/GetStaffStatistics', GetStaff, {mode:'cors'})
  return response.data
  })
  export const getData = createAsyncThunk('appStaff/getData', async (params) => {
      
        const response = await axios.post('https://api.zasway.com:8443/Staff/GetTableSummary', params, {mode:'cors'})
           
        return {
          params,
          data: response.data.data,
          allData: response.data.allData,
          totalPages: response.data.total

        }
     
  })
  export const getStaff = createAsyncThunk('appStaff/getStaff', async (params) => {
     
    
    const response = await axios.post('https://api.zasway.com:8443/Staff/GetTableSummary', params, {mode:'cors'})
     
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
})
  export const EditStaff = createAsyncThunk('appStaff/Update', async (Staff) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Staff/Update', Staff, {mode:'cors'})
   
    return response
  })
export const deleteStaff = createAsyncThunk('appStaff/Delete', async (id, { dispatch, getState }) => {
   
  const response = await axios.post('https://api.zasway.com:8443/Staff/Delete', id, {mode:'cors'})
   
  await dispatch(getData(getState().staff.params))
   
  return response
})

export const getUser = createAsyncThunk('appStaff/getUser', async () => {
     
    const response = await axios.get('https://api.zasway.com:8443/Vendor/GetVendorList', {headers}, data)
    return response.data
    })

export const addUser = createAsyncThunk('appStaff/addUser', async (user, { dispatch, getState }) => {
   
  await axios.post('https://api.zasway.com:8443/User/CreateUser', user, {headers}, {mode:'cors'})
  await dispatch(getData(getState().staff.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appStaff/deleteUser', async (id, { dispatch, getState }) => {
     
    await axios.post('https://api.zasway.com:8443/User/DeleteUser', { id }, {headers}, {mode:'cors'})
    await dispatch(getData(getState().staff.params))
    await dispatch(getAllData())
    return id
  })
  export const getStaffImage = createAsyncThunk('appDriver/GetStaffImage', async (Staff) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Common/GetStaffImage', Staff, {mode:'cors'})
    return response.data
  })
  export const UploadImage = createAsyncThunk('appDriver/UploadImage', async (formData) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Common/UploadImageStaff', formData, {mode:'cors'})
     
    return response
  })
  
  export const getDocumentTypeList = createAsyncThunk('appDriver/getDocumentTypeList', async (OwnerType) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentTypeList', OwnerType, {mode:'cors'})
    return response.data
  })
  export const deleteDocument = createAsyncThunk('appDriver/DeleteDocument', async (id) => {
   
    const response = await axios.post('https://api.zasway.com:8443/Common/DeleteDocument', id, {mode:'cors'})
      return response
  })
  export const EditDocument = createAsyncThunk('appDriver/UpdateDocument', async (formData) => {
    let flag = 0
    const response = await axios.post('https://api.zasway.com:8443/Common/UpdateDocument', formData, {mode:'cors'})
   
    if (response.data.code === 200) { flag = 1 }
    return {  response,
              isSaved:flag
    }
  })
  export const getDocument = createAsyncThunk('appDriver/getDocument', async (Doc) => {
   
    const response = await axios.post('https://api.zasway.com:8443/Common/GetDocument', Doc, {mode:'cors'})
    return response.data
  })
export const addDocument = createAsyncThunk('appDriver/CreateDocument', async (formData) => {
   
  let flag = 0
  const response = await axios.post('https://api.zasway.com:8443/Common/Create', formData, {mode:'cors'})
  if (response.data.code === 200) { flag = 1 }
  return {  response,
            isSaved:flag
  }
})

export const resetFlag = createAsyncThunk('appDriver/ResetFlag', () => {
     
  return {   isSaved:0  }
})
  export const GetDocumentDetailsByOwnerType = createAsyncThunk('appDriver/GetDocumentDetailsByOwner', async (Owner) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentSummaryByOwnerType', Owner, {mode:'cors'})
     
    return response.data
    })
    export const GetDocumentDetailsByID = createAsyncThunk('appDriver/GetDocumentDetailsByID', async (document) => {
   
      const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentDetailByID', document, {mode:'cors'})
       
      return response.data
      })
export const appStaffSlice = createSlice({
  name: 'appStaff',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    selectedDocument:[],
    IsSaved:0
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
       
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
    })
    .addCase(getStaff.fulfilled, (state, action) => {
          
      state.selectedUser = action.payload.allData[0]
    }) 
    .addCase(GetDocumentDetailsByID.fulfilled, (state, action) => {
           
      state.selectedDocument = action.payload
})
.addCase(addDocument.fulfilled, (state, action) => {
   
  state.IsSaved = action.payload.isSaved
})
.addCase(EditDocument.fulfilled, (state, action) => {
   
  state.IsSaved = action.payload.isSaved
})
.addCase(resetFlag.fulfilled, (state, action) => {
   
  state.IsSaved = action.payload.isSaved
})
  }
})

export default appStaffSlice.reducer
